import { render } from "./NoticeCreate.vue?vue&type=template&id=aa923db4&scoped=true"
import script from "./NoticeCreate.vue?vue&type=script&lang=js"
export * from "./NoticeCreate.vue?vue&type=script&lang=js"

import "./NoticeCreate.vue?vue&type=style&index=0&id=aa923db4&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa923db4"]])

export default __exports__